<i18n>
{
  "cl":{
    "active": "Activo",
    "inactive": "Inactivo",
    "assignedCommercialAnalyst": "Ejecutivo comercial asignado"
  },
  "pe":{
    "active": "Activo",
    "inactive": "Inactivo",
    "assignedCommercialAnalyst": "Ejecutivo comercial asignado"
  },
  "br":{
    "simulator": "Simulador",
    "active": "Ativo",
    "inactive": "Inativo",
    "assignedCommercialAnalyst": "Executivo Designado",
    "idNumber": "CNPJ",
    "brokerSourceName": "Nome da fonte do parceiro",
    "brokerSourceOrigin": "Origin do parceiro"
  }
}
</i18n>

<template>
  <section class="container">
    <b-loading v-model="isUpdatingStatus" :is-full-page="false" :can-cancel="false">
      <Spinner />
    </b-loading>

    <div class="broker-actions">
      <h2 class="broker-name">{{ broker.name }}</h2>
      <b-switch
        v-if="!userIsBroker"
        v-model="broker.status"
        :disabled="isUpdatingStatus"
        :native-value="broker.status"
        true-value="ACTIVE"
        false-value="INACTIVE"
        @input="updateBrokerStatusEmit($event)">
        <span>{{ broker.status === "ACTIVE" ? $t("active") : $t("inactive") }}</span>
      </b-switch>
    </div>

    <div class="broker-info-container">
      <b-tooltip
        v-if="broker.idNumber"
        :label="$t('idNumber')"
        position="is-bottom">
        <div v-if="broker.idNumber" class="broker-info">
          <i class="fa-solid fa-address-card has-text-primary" />
          <span>{{ broker.idNumber }}</span>
        </div>
      </b-tooltip>

      <div v-if="broker.email" class="broker-info">
        <a :href="'mailto:' + broker.email "><i class="fa-solid fa-envelope" /></a>
        <span>{{ broker.email }}</span>
      </div>

      <div v-if="broker.phone" class="broker-info">
        <a
          class="broker-phone"
          :href="
            'https://api.whatsapp.com/send?phone=' +
              broker.phone +
              '&text=Ol%C3%A1%20' +
              broker.name
          "
          target="_blank">
          <i class="fab fa-whatsapp" />
        </a>
        <span>{{ broker.phone }}</span>
      </div>

      <b-tooltip
        v-if="broker.assignedCommercialAnalyst"
        :label="$t('assignedCommercialAnalyst')"
        position="is-bottom">
        <div v-if="broker.assignedCommercialAnalyst.name" class="broker-info">
          <i class="fa-solid fa-user-tie" />
          <span>{{ broker.assignedCommercialAnalyst.name }}</span>
        </div>
      </b-tooltip>

      <div
        v-if="broker.prospectsList"
        class="broker-info">
        <i class="fa-solid fa-users" />
        <span>{{ `Leads: ${broker.prospectsList.length}` }}</span>
      </div>
    </div>
    <div>
      <b-tooltip
        v-if="broker.brokerSource"
        :label="$t('brokerSourceName')"
        position="is-bottom">
        <div
          v-if="broker.brokerSource"
          class="broker-info">
          <i class="fa-solid fa-home" />
          <span>{{ broker.brokerSource.name || $t("simulator") }}</span>
        </div>
      </b-tooltip>
    </div>
  </section>
</template>

<script>
import Spinner from '@/ui/components/Spinner.vue';

export default {
  name: 'BrokerData',
  components: { Spinner },
  props: {
    broker: { type: Object },
    userIsBroker: { type: Boolean, default: false },
    isUpdatingStatus: { type: Boolean, default: false }
  },
  methods: {
    updateBrokerStatusEmit(newStatus) {
      this.$emit('updateBrokerStatus', newStatus);
    }
  }
};
</script>

<style scoped>
.container{
  border-bottom: 1px solid var(--color-silver);
  margin-bottom: 3rem;
  padding: 1rem 0;
  text-align: center;
}
.broker-name{
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
}
.broker-info-container,.broker-actions{
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.5rem;
  padding: 1rem;
}
.broker-actions{
  padding: 0;
}
.broker-info,.broker-phone{
  color: var(--primary);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: .3rem;
}
@media(max-width:600px){
.broker-info-container,.broker-actions,.is-secondary{
  font-size: .9rem;
}
}
</style>
